import { render, staticRenderFns } from "./SignatureInput.vue?vue&type=template&id=022a50c4&"
import script from "./SignatureInput.vue?vue&type=script&lang=js&"
export * from "./SignatureInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VBtn,VCard,VInput})
